/** @type {import('../types').ProgramConfig} */
export default {
  code: 'PIFCC',
  displayName: 'PIF Cash Claim Review',
  shortName: 'PIFCC',
  color: 'blue',
  statusLabels: {
    recommend_approval: 'Recommend Approval',
    recommend_rejection: 'Recommend Rejection',
    needs_review: 'Needs Review',
  },
  sidebarItems: [],
  listColumns: [],

  // Keys match the ordered per_check_results written by
  // pifcc_validation_agent/tools/make_decision.py.
  feedback: {
    enabled: true,
    validations: [
      { key: 'step_rule_selection',
        label: '1. Claim Rule Selection',
        keywords: ['rule selection', 'rule_id', 'rule source', 'workaround'] },
      { key: 'step_2_po_4j_approval',
        label: '2. 4J PO India Approval',
        keywords: ['4j', 'aispl', 'india approver', 'step_2'] },
      { key: 'step_cst',
        label: '3. Customer Sign-Off Template',
        keywords: ['cst', 'customer sign-off', 'step_cst'] },
      { key: 'step_pst',
        label: '4. Partner Sign-Off Template',
        keywords: ['pst', 'partner sign-off', 'step_pst'] },
      { key: 'step_3_invoice_present',
        label: '5. Invoice or Receipt Present',
        keywords: ['invoice present', 'receipt', 'step_3'] },
      { key: 'step_4_entity_linkage',
        label: '6. Invoice Entity Linkage',
        keywords: ['entity linkage', 'bill-to', 'step_4'] },
      { key: 'step_5_cost_share',
        label: '7. Cost Share',
        keywords: ['cost share', 'claim amount', 'step_5'] },
      { key: 'step_invoice_billed_to_aws',
        label: '8. Invoice Billed to AWS',
        keywords: ['billed to aws', 'aws invoice'] },
      { key: 'workaround_rule',
        label: '9. Workaround Rule Resolution',
        keywords: ['workaround rule', 'rule unresolved', 'candidate rules'] },
      { key: 'attachment_list',
        label: '10. Attachment List Availability',
        keywords: ['attachment list', 'attachments unavailable', 'file list'] },
    ],
    decisionOptions: [
      { value: 'recommend_approval',  label: 'Recommend Approval' },
      { value: 'recommend_rejection', label: 'Recommend Rejection' },
      { value: 'needs_review',        label: 'Needs Review' },
    ],
  },
};
